/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_EmptyInputs */

const en_us2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I didn't hear anything. Try again closer to the microphone.`)
};

const pt_br2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não ouvi nada. Tente de novo mais perto do microfone.`)
};

const es_419_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No escuché nada. Intenta de nuevo más cerca del micrófono.`)
};

const pt_pt2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não ouvi nada. Tenta outra vez mais perto do microfone.`)
};

const fr_fr2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je n'ai rien entendu. Réessaie plus près du micro.`)
};

const de_de2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe nichts gehört. Versuch es noch mal näher am Mikrofon.`)
};

const it_it2_coach_mic_empty = /** @type {(inputs: Coach_Mic_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ho sentito nulla. Riprova più vicino al microfono.`)
};

/**
* | output |
* | --- |
* | "I didn't hear anything. Try again closer to the microphone." |
*
* @param {Coach_Mic_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_empty = /** @type {((inputs?: Coach_Mic_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_empty(inputs)
	if (locale === "es-419") return es_419_coach_mic_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_empty(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_empty(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_empty(inputs)
	return en_us2_coach_mic_empty(inputs)
});
export { coach_mic_empty as "coach-mic.empty" }